import script from "./PaymentMethodAddMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodAddMobile.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodAddMobile.vue?vue&type=style&index=0&id=44f09e33&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44f09e33"]])

export default __exports__